import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import VueI18n from "vue-i18n";
import VueScrollTo from "vue-scrollto";
import VueWaypoint from "vue-waypoint";

import App from "@/app/App";
import { highlightedLinkify, linkified, vInteract, vTrack } from "@/directives";
import { globalLocales } from "@/globalLocales";
import router from "@/router";
import store from "@/store";
import { microsoftClarityDir } from "@torre-labs/microsoft-clarity";

import { CookieService } from "@/services/CookieService";
import { OpportunitiesService } from "@/services/OpportunitiesService";
import { LazyLoaderDirective, VeeInstallDefaultRules, VeeInstallTorreRules } from "@torre-labs/material";

Vue.config.productionTip = false;

Vue.use(VueClipboard);
Vue.use(VueI18n);
Vue.use(VueScrollTo);
Vue.use(VueWaypoint);

Vue.directive("highlightedLinkify", highlightedLinkify );
Vue.directive("linkified", linkified);
Vue.directive("microsoft-clarity", microsoftClarityDir);
Vue.directive("track", vTrack);
Vue.directive("interact", vInteract);
Vue.directive("lazyload", LazyLoaderDirective);

const i18n = new VueI18n({
  locale: `${process.env.VUE_APP_DISCOVERY_DEFAULT_LOCALE}`,
  messages: globalLocales,
  silentTranslationWarn: true
});

VeeInstallDefaultRules();
VeeInstallTorreRules();

const availableLanguages = ["es", "en"];

router.beforeEach((to, from, next) => {
  const routeWithLocale = availableLanguages.find((al) => to.path.startsWith(`/${al}/`));
  if (routeWithLocale && to.name !== "onboarding") {
    const newPath = to.path.substring(`/${routeWithLocale}`.length);
    const newParams = {...to.params};
    delete newParams.locale;
    // @ts-ignore
    next({ ...to, params: newParams, path: newPath });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");

const changeLocale = (newLocale: string) => {
  const validLanguage = newLocale ? availableLanguages.find((al) => al === newLocale) : process.env.VUE_APP_DISCOVERY_DEFAULT_LOCALE;
  i18n.locale = validLanguage || process.env.VUE_APP_DISCOVERY_DEFAULT_LOCALE!;
  const html = document.documentElement;
  html.setAttribute("lang", i18n.locale);
};

router.afterEach((to) => {
  const pagesWithOpportunityLocale = ["automessages", "memberPreferences", "membersList", "membersListConfirmed", "invitationUnavailable"];

  if ((to.name === "pipeline" && to.params.id) || (pagesWithOpportunityLocale?.includes(to.name ?? "") && to.params.opportunityId)) {
    const oppId = to.name === "pipeline" ? to.params.id : to.params.opportunityId;
    OpportunitiesService.getLocale(oppId)
      .subscribe((locale) => {
        changeLocale(locale.locale);
      }, () => {
        changeLocale(CookieService.getCookie("torre.locale") as string);
      });
  } else {
    changeLocale(CookieService.getCookie("torre.locale") as string);
  }
});
